<template>
  <div v-if="graduate.id" class="container-fluid container-boxed">
    <div class="card">
      <div class="card-body">
        <h2>{{ graduate.program.name }}</h2>

        <div class="row">
          <div class="col-lg mt-2">
            <p class="text-truncate mb-0">
              <strong>Current placement:</strong>
              <br>{{ currentPlacementAgency }}
            </p>
          </div>
          <div class="col-lg mt-2">
            <p class="text-truncate mb-0">
              <strong>Current manager:</strong>
              <br>{{ currentPlacementManager ? currentPlacementManager.name : 'Unassigned' }}
            </p>
          </div>
          <div class="col-lg mt-2">
            <p class="text-truncate mb-0">
              <strong>Home agency:</strong>
              <br>{{ homeAgency }}
            </p>
          </div>
        </div><!-- /.row -->
      </div>
    </div><!-- /.card -->

    <div class="decorative-divider"></div>

    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title">Tasks</h2>
      </div>
      <ul class="list-data">
        <no-results v-if="haveNoTasks">
          There are no tasks available.
        </no-results>
        <task-list-item v-for="task in tasks" :task="task" :key="task.id"/>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->
  </div><!-- /.container-fluid -->
</template>

<script>
import { graduateComputed, graduateMethods, taskComputed, taskMethods } from 'vx/helpers'
import { helpers } from 'mixins/graduates'
import TaskListItem from './DashboardTaskListItem'

export default {
  mixins: [helpers],

  components: {
    TaskListItem
  },

  computed: {
    ...graduateComputed,
    ...taskComputed,

    haveNoTasks () {
      return this.tasks.length === 0
    }
  },

  async created () {
    await this.getGraduate(this.$user.id)
    await this.getTasks()
  },

  methods: {
    ...graduateMethods,
    ...taskMethods
  }
}
</script>
